import type { PersonalizeItem } from "@shared/schemas";
import { FORMATS } from "@shared/pricing";

export type CartEntry = PersonalizeItem & {
  id: string;
  priceCents: number;
  formatName: string;
};

const STORAGE_KEY = "hb_cart_v1";

export function loadCart(): CartEntry[] {
  if (typeof sessionStorage === "undefined") return [];
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as CartEntry[]) : [];
  } catch {
    return [];
  }
}

export function saveCart(items: CartEntry[]): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function clearCart(): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(STORAGE_KEY);
}

export function makeCartEntry(item: PersonalizeItem): CartEntry {
  const fmt = FORMATS[item.format];
  return {
    ...item,
    id: "i_" + Math.random().toString(36).slice(2, 10),
    priceCents: fmt.priceCents,
    formatName: fmt.name,
  };
}
